import React from "react";

const Title = ({ children }) => (
  <div className="text-orange-500 font-bold text-xl border-0 border-b border-gray-300 pb-2 mt-4 mb-2">
    {children}
  </div>
);

export default Title;
